<template>
  <div class="main-layout">
    <div class="layout-head">
      <logo/>
      <user-management/>
    </div>

    <div class="layout-body">
      <div class="layout-body-left" v-if="userStatus === '1'">
        <menus/>
      </div>
      <div :class="'layout-body-middle ' + (this.$route.path.indexOf('/admin/home') > -1 && enterpriseButton ? '':'layout-body-middle-changeToRight ')">
        <div class="breadcrumb el-breadcrum--standard" v-if="userStatus === '1'">
          <bread-crumb></bread-crumb>
        </div>
        <div class="container" >
          <transition name="slide-fade">
            <router-view/>
          </transition>
        </div>
      </div>
      <div v-if="this.$route.path.indexOf('/admin/home') > -1 && userStatus === '1' && enterpriseButton" class="layout-body-right main_content_right">
        <system-message></system-message>
      </div>

    </div>

    <div class="layout-bottom">
      版权所有&copy;&nbsp;&nbsp;中创时代云计算（天津）有限公司
      <a style="margin-left:20px;text-decoration: none;color: rgba(0, 0, 0, 0.65);"  href="https://beian.miit.gov.cn" target="_blank">津ICP备2025031704号</a>
    </div>
  </div>
</template>

<script>
  import menus from './components/Menus'
  import logo from './components/Logo'
  import userManagement from './components/UserManagement'
  import breadCrumb from '@/components/Breadcrumb'
  import {getCookie} from '@/utils/cookie'
  import SystemMessage from '../../views/home/enterprise/systemMessage'

  export default {
    name: 'mainLayout',
    components: {
      menus,
      logo,
      userManagement,
      breadCrumb,
      SystemMessage
    },
    created() {
      this.userStatus = getCookie('userStatus')
      this.common.httpPost('判断是否是企业', '/admin/system/user/getUserInfo', {}).then((res) => {
         if(res!=undefined){
           if(res.data.loginUserType==2){
              this.enterpriseButton=true
           }
         }
        })
    },
    data() {
      return {
        enterpriseButton:false,
        userStatus:undefined,
      }
    }
  }
</script>

<style lang="scss" scoped>
  // style dependency
  @import "@/assets/styles/variables.scss";

  .main-layout {
    height: 100vh;
    width: 100vw;
    display: flex;
    flex-direction: column;

    > .layout-head {
      height: $headHeight;
      background-color: $headBackgroundColor;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: $headPadding;
    }

    > .layout-body {
      height: calc(100vh - #{$headHeight + $bottomHeight});
      width: 100%;
      display: flex;
      background: $bodyBackgroundColor;

      > .layout-body-left {
        height: 100%;
        width: $menuWidth;
        min-width: $menuWidth;
        display: flex;
        flex-direction: column;
        background: $menuBackground;
        margin-left:30px;
      }

      > .layout-body-middle-changeToRight {
        width: calc(100% - #{$menuWidth} - 30px) !important;
      }

      > .layout-body-middle {
        width: calc(100% - #{$menuWidth} - 30px - 430px);
        display: flex;
        flex-direction: column;

        > .breadcrumb {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: $breadcrumbHeight;
          min-height: $breadcrumbHeight;
          margin: 0 12px;
          background: $mainContainerBackground;
        }

        > .container {
          height: calc(100vh - #{$headHeight + $bottomHeight + $breadcrumbHeight});
          margin: 0;
          overflow: hidden;
          background-color: $mainContainerBackground;

          .slide-fade-enter-active {
            transition: all .2s ease .2s;
          }

          .slide-fade-leave-active {
            transition: all .2s ease;
          }

          .slide-fade-enter, .slide-fade-leave-to {
            transform: translateX(100px);
            opacity: 0;
          }
        }
      }

      > .layout-body-right {
        width: 400px;
      }
    }

    > .layout-bottom {
      color: $bottomFontColor;
      font-size: $fontSize;
      height: $bottomHeight;
      display: flex;
      align-items: center;
      justify-content: center;
      border-top: solid 1px #e6e6e6;
      margin-top:20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MainLayout/index.vue